import { bulkClauseApiProp } from "../../../vscDashboard/constants";
import Breadcrumb from "../../../../components/Breadcrumb/Breadcrumb";
import Table from "../../../../components/Table/Table";
import AdminDashboardStyles from "./AdminDashboard.module.scss";
import { breadCrumbData, ROUTES } from "../../../../common/constants";
import { TableTypes } from "../../../ManageContract/constants";

import { useAppDispatch, useAppSelector } from "../../../../hooks/store";

import { useNavigate } from "react-router-dom";

import { getToast } from "../../../../common/utils";

import { useBreadCrumbHook } from "../../../../hooks/common";

import { setDataForRoleManagement } from "../../store/admin.thunk";
import Modal from "../../../../components/Modal/Modal";
import { useState } from "react";
import { UserRolesKey } from "../../constants";
import Typography from "../../../../components/Typography/Typography";
import { Button, Checkbox, Radio } from "antd";
import { updateUserRole } from "../../admin.service";
// import { Tooltip } from "@mui/material";
import Tooltip from "../../../../components/Tooltip/Tooltip";
import infoIconSvg from "../../../../assets/images/UserTable/InfoIcon.svg";
import { ImageBadgeName } from "../../../../common/common";
import { getTableDataThunk } from "../../../../store/thunks/table.thunk";

const AdminDashboard = () => {
  const [showEditUserModal, setShowEditUserModal] = useState(false);
  const dispatch = useAppDispatch();
  const [isSaveLoading, setIsSaveLoading] = useState(false);  
  const manageRoleData = useAppSelector(
    (store) => store.rootReducer.adminReducer.roleManagementData
  );
  const rolesData = useAppSelector(
    (store) => store?.rootReducer?.userInfoReducer?.rolesData
  );
  const allAvailableRoles = rolesData?.data;
  const adminRoleData = allAvailableRoles?.filter(
    (role: any) => role?.name === UserRolesKey.ADMIN
  )[0];

  const userData = useAppSelector(
    (store) => store?.rootReducer?.userInfoReducer?.details
  );
  const { data } = useAppSelector(
    (store) => store?.rootReducer?.tableInfoReducer
  );
  const page = data?.[TableTypes.USER_MANAGEMENT]?.page || 1;
  const count = data?.[TableTypes.USER_MANAGEMENT]?.toBeRetrieved;
  const navigate = useNavigate();
  const [breadCrumb] = useBreadCrumbHook([
    breadCrumbData.dashboard,
    breadCrumbData.userManagment,
  ]);

  const updateModelData = (obj: any) => {};

  const handleEditClick = async (data: any) => {
    if (data?.userId === userData?.email) {
      getToast("Error", "Action not allowed");
    } else {
      await dispatch(setDataForRoleManagement(data));
      setShowEditUserModal(true);
      // navigate(ROUTES.manageRole);
    }
  };

  const handleUserRoleSave = async () => {
    try {
      await updateUserRole({
        user_id: manageRoleData?.id,
        role_ids: manageRoleData?.roles?.map((role: any) => role?.id),
      });
      
      dispatch(getTableDataThunk(TableTypes.USER_MANAGEMENT, page, count));
      getToast("Success", "Role Updated Successfully");
      setShowEditUserModal(false);
    } catch (err) {}
  };

  const handleRadioChange = (value: any, role: any) => {
    const temp = [...manageRoleData?.roles];

    let index = -1;
    temp.forEach((item, idx) => {
      if (item?.id === role?.id) {
        index = idx;
      }
    });

    if (index === -1) {
      temp.push(role);
    } else {
      temp.splice(index, 1);
    }
    // setModelData({ ...modelData, roles: temp, powerUser: value });
    dispatch(setDataForRoleManagement({ roles: temp, powerUser: value }));
  };

  const handleCheckBox = (value: any) => {
    const temp = [...manageRoleData?.roles];
    let index = -1;
    temp.forEach((item, idx) => {
      if (item?.id === value?.id) {
        index = idx;
      }
    });
    if (index === -1) {
      temp.push(value);
    } else {
      temp.splice(index, 1);
    }
    // setModelData({ ...modelData, roles: temp });
    dispatch(setDataForRoleManagement({ roles: temp }));
  };

  return (
    <div className={AdminDashboardStyles.wrapper}>
      {/* <Breadcrumb list={breadCrumb} styles={{ marginBottom: "0" }} /> */}

      <span className={AdminDashboardStyles.title}>User Management</span>

      <Table
        entity={TableTypes.USER_MANAGEMENT}
        apiProps={bulkClauseApiProp}
        updateModelData={updateModelData}
        handleEditClick={handleEditClick}
        poling={false}
      />

      <div className={AdminDashboardStyles.modal}>
        <Modal
          open={showEditUserModal}
          onCancel={() => setShowEditUserModal(false)}
          title="Manage Role"
          footer={[
            <div className={AdminDashboardStyles.modalFooter}>
              <Button variant="outlined" onClick={() => setShowEditUserModal(false)}>
                Cancel
              </Button>
              <Button 
                className={AdminDashboardStyles.saveButton} 
                onClick={handleUserRoleSave}
                disabled={manageRoleData?.roles?.length === 0}
              >
                Save
              </Button>
            </div>,
          ]}
        >
          <div className={AdminDashboardStyles.roleContent}>
            <div className={AdminDashboardStyles.nameInfo}>
              <div className={AdminDashboardStyles.userPicture}>
                {/* <img src={manageRoleData?.picture} alt="User Profile" /> */}
                <ImageBadgeName
                  height="54px"
                  width="54px"
                  fontSize="25px"
                  // loading={loading}
                />
              </div>
              <div className={AdminDashboardStyles.userTitle}>
                <Typography className={AdminDashboardStyles.name}>
                  {manageRoleData?.name}
                </Typography>
                <Typography className={AdminDashboardStyles.email}>
                  {manageRoleData?.email}
                </Typography>
              </div>
            </div>
            <div className={AdminDashboardStyles.radio}>
              <div className={AdminDashboardStyles.radioTitle}>
                <p className={AdminDashboardStyles.roleHead}>Power User</p>
                <Tooltip title={adminRoleData?.description} placement="right">
                  <img src={infoIconSvg} alt="" width={16} height={16} />
                </Tooltip>
              </div>
              <Radio.Group
                onChange={(e) =>
                  handleRadioChange(e.target.value, adminRoleData)
                }
                value={manageRoleData?.powerUser}
              >
                <Radio value={true}>Yes</Radio>
                <Radio value={false}>No</Radio>
              </Radio.Group>
            </div>
            <div className={AdminDashboardStyles.otherRoles}>
              <Typography fontSize={14} fontWeight={500} className={AdminDashboardStyles.roleHead}>
                Roles
              </Typography>
              <div className={AdminDashboardStyles.roleList}>
                {allAvailableRoles
                  ?.filter((role: any) => role?.name !== "admin")
                  ?.map((role: any) => {
                    return (
                      <div className={AdminDashboardStyles.roleListItem}>
                        <Checkbox
                          checked={
                            manageRoleData?.roles?.some(
                              (urole: any) => urole?.id === role?.id
                            ) || manageRoleData?.powerUser
                          }
                          disabled={manageRoleData?.powerUser}
                          value={role}
                          onChange={(e) => handleCheckBox(e.target.value)}
                        />
                        {" "}
                        <Typography className={AdminDashboardStyles.itemTitle}>
                          {role?.display_name}{" "}
                        </Typography>
                        {" "}
                        <Tooltip title={role?.description} placement="right">
                          <img src={infoIconSvg} alt="" width={16} height={16} />
                        </Tooltip>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default AdminDashboard;
